import { render, staticRenderFns } from "./Evento_deporte_prematch.vue?vue&type=template&id=10ef38f3&"
import script from "./Evento_deporte_prematch.vue?vue&type=script&lang=js&"
export * from "./Evento_deporte_prematch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports